import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

import Footer from "../ones/Footer";
import NewsBanner from "../ones/NewsBanner";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		// run initializations here
		setReady(false);
		// ..
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	if (ready) {
		return (
			<>
				<NewsBanner />
				{ appContext.navItem === 'news' ? <Footer/> : '' }
			</>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
